'use strict';
'use es6';

if (!String.prototype.endsWith) {
  // eslint-disable-next-line no-extend-native
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/polyFills.js
// module id = 1
// module chunks = 0 1